export default "__VITE_ASSET__0f03edc6__"